import React from 'react';

export default function PlaceImage(props) {
  return <img {...props} onError={event => {
    if (!event.currentTarget.src.endsWith('/images/photo-unavailable.svg')) {
      event.currentTarget.src = `${process.env.PUBLIC_URL}/images/photo-unavailable.svg`;
    }
  }} />;
}
